import gql from 'graphql-tag'

export const GET_PART_TO_SERVICE_ORDER = gql`
  query Part2Services($filter: GetPart2ServicesFilter!) {
    part2Services(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      part2Services {
        data {
          service2SoId
          partId
          qty
          price
          discount
          totalPrice
          unit
          note
          part {
            partId
            partTypeId
            partBrandId
            code
            name
            sku
            quality
            description
            unit
            price
            partType {
              type
              partTypeId
              partCategory {
                category
              }
            }
            partBrand {
              brand
              partBrandId
            }
          }
        }
        pagination {
          page
          show
          total
        }
      }
    }
  }
`

export const GET_PART_TO_SERVICE_ORDER_BY_ID = gql`
  query Part2Service($filter: GetPart2ServiceFilter!) {
    part2Service(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      part2Service {
        service2SoId
        partId
        qty
        price
        totalPrice
        discount
        unit
        note
        part {
          partId
          partTypeId
          code
          name
          sku
          quality
          description
          unit
          price
          partType {
            partCategory {
              category
            }
            type
          }
        }
      }
    }
  }
`

export const CREATE_PART_TO_SERVICE_ORDER = gql`
  mutation CreatePart2Service($input: CreatePart2ServiceInput!) {
    createPart2Service(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      createPart2Service {
        service2SoId
        partId
        qty
        price
        totalPrice
        discount
        unit
        note
        part {
          partId
          partTypeId
          code
          name
          sku
          quality
          description
          unit
          price
          partType {
            partCategory {
              category
            }
            type
          }
        }
      }
    }
  }
`

export const UPDATE_PART_TO_SERVICE_ORDER = gql`
  mutation UpdatePart2Service($input: UpdatePart2ServiceInput!) {
    updatePart2Service(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      updatePart2Service {
        service2SoId
        partId
        qty
        price
        totalPrice
        discount
        unit
        note
        part {
          partId
          partTypeId
          code
          name
          sku
          quality
          description
          unit
          price
          partType {
            partCategory {
              category
            }
            type
          }
        }
      }
    }
  }
`

export const DELETE_PART_TO_SERVICE_ORDER = gql`
  mutation DeletePart2Service($input: DeletePart2ServiceInput!) {
    deletePart2Service(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
    }
  }
`
